import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const PrivateRoute = ({ requiredAccess, fallback, children }) => {
  const { isAuthenticated, hasAccess, loading } = useAuth();
  const location = useLocation();

  // Wait for the initial session check — otherwise a hard reload on a
  // protected route bounces through /login before the session resolves
  if (loading) {
    return <LoadingSpinner />;
  }

  // First check if user is authenticated
  if (!isAuthenticated) {
    // If a fallback is provided, render it instead of redirecting
    if (fallback) {
      return fallback;
    }
    // Redirect to login page, but save the location they were trying to access
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If requiredAccess is specified, check if user has that access
  if (requiredAccess && !hasAccess(requiredAccess)) {
    // Redirect to access denied page
    return <Navigate to="/access-denied" replace />;
  }

  // If authenticated and has required access, render children or child routes
  return children ? children : <Outlet />;
};

export default PrivateRoute;